import { render, staticRenderFns } from "./AudioShopUpload.vue?vue&type=template&id=327038f9&scoped=true"
import script from "./AudioShopUpload.vue?vue&type=script&lang=ts"
export * from "./AudioShopUpload.vue?vue&type=script&lang=ts"
import style0 from "./AudioShopUpload.vue?vue&type=style&index=0&id=327038f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327038f9",
  null
  
)

export default component.exports